// "When do you usually work on your company?" — asked in onboarding, editable
// in Settings. Saved via PUT /api/users/me/build-time; the backend
// (services/work_time.py) turns it into the brief hour, the hours the brief's
// "Block 30 min" button looks in, and "Tonight" wording for evening builders.
export const BUILD_TIME_OPTIONS = [
  { value: 'mornings', label: 'Mornings', hint: 'Brief at 7 AM' },
  { value: 'lunch', label: 'Lunch', hint: 'Brief at 11 AM' },
  { value: 'evenings', label: 'Evenings', hint: 'Brief at 6 PM' },
  { value: 'weekends', label: 'Weekends', hint: 'Sat & Sun, 8 AM' },
];
